import { gql } from "apollo-boost";

const GET_PRODUCT_DETAILS = gql`
  query getProductDetail($input: CheckProductStatus) {
    getProductDetail(input: $input) {
      status
      error
      data {
        hasMore
        productList {
          handle
          title
          body
          vendor
          type
          tags
          collectionData
          published
          giftCard
          sku
          imageSrc
          imageAltText
          variants {
            option1Name
          }
        }
      }
    }
  }
`;

export default GET_PRODUCT_DETAILS;
